import React, { useState } from "react";
import { SdfButton, SdfSpotIllustration } from '@synerg/react-components'
import { ImportModal } from "./importModal";

export const ILProjectListTable = (props = {}) => {
  const {
    projectList = [],
    setLoading,
    setShowToast,
    setError,
    setInfoMessage,
    reloadProjectList,
  } = props;

  const [modalObj, setModalObj] = useState({ visiable: false, data: {} });

  const tableCols = [
    { label: "CAR app name", className: "py-3 pl-4 pr-3", width: 20 },
    { label: "Consumer app ID", className: "py-3 pr-3", width: 25 },
    { label: "OOID", className: "py-3 pr-3", width: 20 },
    { label: "App type", className: "py-3 pr-3", width: 12 },
    { label: "Has companion connector?", className: "py-3 pr-3", width: 15 },
    { label: " ", className: "py-3 pr-3", width: 8 },
  ];

  return (
    <React.Fragment>
      {projectList.length === 0 ? (
        <div
          className="w-full flex justify-center items-center"
          style={{ height: "calc(100vh - 300px)" }}
        >
          <div className="text-center">
            <SdfSpotIllustration
              illustrationName={"empty-magnifying-glass"}
              size={"md"}
            ></SdfSpotIllustration>
            <div className="text-body-02 font-medium empty-search mt-4">
              No legacy projects found yet!
            </div>
            <div className="text-body-01 empty-search mt-5">
              Enter the partner OOID in the search field and select find
              projects.
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full">
          <div className="inline-flex w-full bg-action-default-200 rounded-t-lg">
            {tableCols.map((col, idx) => (
              <div
                key={idx}
                className={`${col.className} text-heading-01 font-bold overflow-ellipsis truncate`}
                style={{ width: col.width + "%" }}
              >
                {col.label}
              </div>
            ))}
          </div>
          <div
            className="w-full overflow-auto text-sm"
            style={{ maxHeight: "calc(100vh - 275px)" }}
          >
            {projectList.map((item, idx) => {
              const type =
                item.grantTypeCode === "authorization_code"
                  ? "End-user app"
                  : "Data connector";
              const companion = item.connectorApplicationID ? "YES" : "NO";
              return (
                <div
                  key={idx}
                  className="inline-flex w-full"
                  style={{ borderBottom: "1px solid #dde2eb" }}
                >
                  <div
                    className="w-1/2 py-3 pl-4 pr-3 overflow-ellipsis truncate"
                    style={{ width: "20%" }}
                  >
                    {item.projectName}
                  </div>
                  <div
                    className="w-1/2 py-3 pr-3 overflow-ellipsis truncate"
                    style={{ width: "25%" }}
                  >
                    {item.consumerApplicationID}
                  </div>
                  <div
                    className="w-1/2 py-3 pr-3 overflow-ellipsis truncate"
                    style={{ width: "20%" }}
                  >
                    {item.ooid}
                  </div>
                  <div
                    className="w-1/2 py-3 pr-3 overflow-ellipsis truncate"
                    style={{ width: "12%" }}
                  >
                    {type}
                  </div>
                  <div className="w-1/2 py-3 pr-3" style={{ width: "15%" }}>
                    {companion}
                  </div>
                  <div
                    className="w-1/2 py-3 pr-3 text-center text-md"
                    style={{ width: "8%" }}
                  >
                    <SdfButton
                      variant="text"
                      emphasis="tertiary"
                      onClick={() =>
                        setModalObj({ visiable: true, data: item })
                      }
                    >
                      Import
                    </SdfButton>
                  </div>
                </div>
              );
            })}
            {projectList.length === 0 ? (
              <div
                className="text-sm w-full p-4"
                style={{ borderBottom: "1px solid #dde2eb" }}
              >
                No rows to show.
              </div>
            ) : null}
          </div>
        </div>
      )}
      {modalObj.visiable ? (
        <ImportModal
          project={modalObj.data}
          setModalObj={setModalObj}
          setLoading={setLoading}
          setShowToast={setShowToast}
          setError={setError}
          setInfoMessage={setInfoMessage}
          reloadProjectList={reloadProjectList}
        />
      ) : null}
    </React.Fragment>
  );
};
